<template>
  <div class="row">

    <div class="col-12 px-0">
      <h1 class="d-flex align-items-center ">
        <span class="icon mr-2 icon-settings_profil_verwalten" aria-hidden="true"></span>
        {{ $t('views.roomEditImage.title') }}
      </h1>
    </div>

    <div class="col-12 px-0">
      <link-back to="/rooms" i18nMessage="common.backToOverview" class="mb-3" />
    </div>

    <div class="col-12 px-0">
      <p class="mb-4">{{ $t('views.roomEditImage.infoText') }}</p>
    </div>

    <loading-container :state="state" errorLinkTo="/rooms">
      <form @submit.prevent="onSubmit()">

        <div class="row mx-auto">
          <div class="col-12 col-md-4 px-0 pr-sm-2">
            <room-image :room="room" />
          </div>
          <div class="col-12 col-md-8 px-0 px-sm-2 mt-2">

            <control-image
              i18nLabel="common.room.imageFile"
              :validation="v$.imageFile"
              v-model="imageFile"
            />

            <control-input
              i18nLabel="common.room.imageAlt"
              :validation="v$.imageAlt"
              v-model="imageAlt"
              class="mt-3"
            />
          </div>
        </div>

        <div class="row mx-auto mt-4">
          <div class="col-12 col-md-4 col-lg-3 offset-lg-1 mt-1 px-xs-0">
            <button-cancel to="/rooms" class="btn-w-100" />
          </div>
          <div class="col-12 col-md-4 col-lg-3 mt-1 px-xs-0">
            <button-delete i18nMessage="views.roomEditImage.delete" v-on:clicked="deleteImage()" class="btn-w-100" />
          </div>
          <div class="col-12 col-md-4 col-lg-3 mt-1 px-xs-0">
            <button-save i18nMessage="views.roomEdit.save" class="btn-w-100" />
          </div>
        </div>

      </form>
    </loading-container>
  </div>
</template>

<script lang="ts">
import ControlImage from '@/components/controls/ControlImage.vue'
import ControlInput from '@/components/controls/ControlInput.vue'
import RoomImage from '@/components/info/RoomImage.vue'
import ButtonCancel from '@/components/interaction/ButtonCancel.vue'
import ButtonSave from '@/components/interaction/ButtonSave.vue'
import ButtonDelete from '@/components/interaction/ButtonDelete.vue'
import LoadingContainer from '@/components/structure/LoadingContainer.vue'
import { Room } from '@/generated/openapi'
import LoadingMixin from '@/mixins/LoadingMixin'
import { adminService } from '@/services/adminService'
import { validateAndFocusInvalid } from '@/utils/formUtils'
import { imageMaxSize, imageJpegOrPng, imageRequired } from '@/utils/validationUtils'
import { LoadingState } from '@/utils/loadingUtils'
import { urlParamString } from '@/utils/navigationUtils'
import { useVuelidate } from '@vuelidate/core'
import { maxLength, minLength, required } from '@vuelidate/validators'
import { defineComponent } from 'vue'
import LinkBack from '@/components/interaction/LinkBack.vue'
import { InfoPopupBase, InfoPopupType } from '@/models/InfoPopupData'


export default defineComponent({
  name: 'RoomEditImage',
  mixins: [
    LoadingMixin
  ],
  components: {
    LoadingContainer,
    ControlInput,
    ControlImage,
    ButtonSave,
    ButtonCancel,
    ButtonDelete,
    RoomImage,
    LinkBack
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  data() {
    return {
      room: {} as Room,
      imageFile: undefined as File|undefined,
      imageAlt: ''
    }
  },
  created() {
    adminService.getRoom(urlParamString(this.$route, 'id')).then(room => {
      this.room = room
      this.imageAlt = room.imageAlt || ''
      this.state = LoadingState.success
    }).catch(this.handleError)
  },
  validations() {
    return {
      imageFile: {
        imageRequired,
        imageMaxSize,
        imageJpegOrPng
      },
      imageAlt: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(150)
      }
    }
  },
  methods: {
    onSubmit() {
      validateAndFocusInvalid(this.v$, this.$el).then(this.uploadImage)
    },
    uploadImage() {
      this.state = LoadingState.loading;
      adminService.uploadImage(this.room.id, this.imageAlt, this.imageFile as File).then(() => {
        this.$store.commit('addInfoPopup', {
          title: this.$t('views.roomEditImage.infopopup.edit'),
          type: InfoPopupType.info
        } as InfoPopupBase)
        this.$router.push('/rooms')
      }).catch(this.handleError)
    },
    deleteImage() {
      adminService.deleteImage(this.room.id).then(() => {
        this.$store.commit('addInfoPopup', {
          title: this.$t('views.roomEditImage.infopopup.delete'),
          type: InfoPopupType.info
        } as InfoPopupBase)
        this.$router.push('/rooms')
      }).catch(this.handleError)
    }
  }
});
</script>
